/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

// You can delete this file if you're not using it

exports.onRouteUpdate = ({ location }) => {
  if (typeof window !== "undefined") {
    const isFR = location.pathname.startsWith('/fr')
    const lang = isFR ? 'fr' : 'en'
    document.documentElement.lang = lang
  }
}